<template>
  <div>
    <b-modal
      v-model="showApproveConfirm"
      title="อนุมัติการจัดการสต๊อก"
      size="md"
      centered
      no-close-on-backdrop
    >
      <p
        v-if="showOlderPendingWarning"
        class="older-pending-warning"
      >
        <template v-if="isOlderPhysicalCountPending">
          พบรายการตรวจนับสต๊อกก่อนหน้าที่ยังไม่ถูกอนุมัติ
          หากดำเนินการอนุมัติรายการนี้
          ระบบจะยกเลิกการตรวจนับสต๊อกก่อนหน้าโดยอัตโนมัติ
        </template>
        <template v-else>
          พบรายการจัดการสต๊อกก่อนหน้าที่ยังไม่ถูกอนุมัติ
          แนะนำให้อนุมัติรายการดังกล่าวก่อน เพื่อความถูกต้องของสต๊อก
        </template>
      </p>
      <p>
        <template v-if="needsHqApprove">
          เมื่ออนุมัติแล้ว จะไม่สามารถแก้ไขได้
          และรายการจะถูกส่งต่อให้สำนักงานใหญ่อนุมัติ
          คุณต้องการอนุมัติการจัดการสต๊อกนี้ใช่หรือไม่?
        </template>
        <template v-else>
          เมื่ออนุมัติแล้ว จะไม่สามารถแก้ไขได้ และสต๊อกจะถูกอัปเดต
          <br />คุณต้องการอนุมัติการจัดการสต๊อกนี้ใช่หรือไม่?
        </template>
      </p>
      <template v-slot:modal-footer>
        <b-button
          class="cancel-btn"
          variant="outline-secondary"
          @click="showApproveConfirm = false"
          >ย้อนกลับ</b-button
        >
        <b-button
          class="confirm-btn"
          variant="primary"
          @click="handleApproveConfirm"
          >ยืนยันอนุมัติ</b-button
        >
      </template>
    </b-modal>

    <b-modal
      v-model="showRejectModal"
      :title="rejectModalTitle"
      size="md"
      centered
      no-close-on-backdrop
    >
      <p class="mb-3">{{ rejectModalDescription }}</p>
      <div class="d-flex align-items-start gap-2">
        <span class="reject-label">เหตุผล:</span>
        <div class="flex-grow-1">
          <b-form-input
            v-model="rejectReason"
            placeholder="กรอกรายละเอียด"
            maxlength="500"
            class="reject-reason-input"
            :state="rejectSubmitAttempted && !rejectReason.trim() ? false : null"
          ></b-form-input>
          <div class="reason-templates mt-2">
            <b-badge
              v-for="tpl in rejectReasonTemplates"
              :key="tpl"
              variant="light"
              class="reason-template-chip"
              @click="applyRejectTemplate(tpl)"
            >
              + {{ tpl }}
            </b-badge>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          class="cancel-btn"
          variant="outline-secondary"
          @click="handleRejectCancel"
          >ย้อนกลับ</b-button
        >
        <b-button
          class="btn-reject-adj"
          variant="outline-danger"
          @click="handleRejectConfirm"
          >ยืนยันปฏิเสธ</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "HQApprovalActionModal",
  props: {
    needsHqApprove: { type: Boolean, default: false },
    showOlderPendingWarning: { type: Boolean, default: false },
    isOlderPhysicalCountPending: { type: Boolean, default: false },
    itemType: { type: String, default: "ADJ" },
  },
  computed: {
    isGR() {
      return this.itemType === "GR";
    },
    rejectModalTitle() {
      return this.isGR ? "ปฏิเสธใบรับสินค้า" : "ปฏิเสธการจัดการสต๊อก";
    },
    rejectModalDescription() {
      return this.isGR
        ? "กรุณากรอกเหตุผลการปฏิเสธใบรับสินค้า เพื่อบอกรายละเอียดให้ทีมงานดำเนินการแก้ไข"
        : "กรุณากรอกเหตุผลการปฏิเสธการจัดการสต๊อก เพื่อบอกรายละเอียดให้ทีมงานดำเนินการแก้ไข";
    },
  },
  data() {
    return {
      showApproveConfirm: false,
      showRejectModal: false,
      rejectReason: "",
      rejectSubmitAttempted: false,
      rejectReasonTemplates: [
        "วันที่ไม่ถูกต้อง",
        "เลือกรายการที่ใช้ไม่ถูกต้อง",
        "ปริมาณไม่ถูกต้อง",
      ],
    };
  },
  methods: {
    showApprove() {
      this.showApproveConfirm = true;
    },
    showReject() {
      this.showRejectModal = true;
    },
    handleApproveConfirm() {
      this.showApproveConfirm = false;
      this.$emit("approve");
    },
    handleRejectConfirm() {
      this.rejectSubmitAttempted = true;
      if (!this.rejectReason.trim()) return;
      this.showRejectModal = false;
      this.rejectSubmitAttempted = false;
      this.$emit("reject", this.rejectReason);
      this.rejectReason = "";
    },
    handleRejectCancel() {
      this.showRejectModal = false;
      this.rejectSubmitAttempted = false;
      this.rejectReason = "";
    },
    applyRejectTemplate(tpl) {
      const base = this.rejectReason.trim();
      this.rejectReason = base ? `${base} ${tpl}` : tpl;
    },
  },
};
</script>

<style scoped>
.older-pending-warning {
  color: #bb342f;
}

.btn-reject-adj {
  padding: 8px 50px;
  font-size: 14px;
  font-weight: 600;
  background-color: #dd3333;
  border-color: #dd3333;
  color: #fff;
}

.btn-reject-adj:hover {
  background-color: #bb2222;
  border-color: #bb2222;
  color: #fff;
}

.reject-label {
  font-weight: 600;
  white-space: nowrap;
  padding-top: 6px;
  padding-right: 10px;
}

.reject-reason-input {
  background-color: #ccecff6c;
}

.reject-reason-input.is-invalid {
  background-image: none;
}

.reason-templates {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}

.reason-template-chip {
  cursor: pointer;
  border: 1px solid #dce1e8;
  font-weight: 500;
}

.reason-template-chip:hover {
  background: #eef2f7;
}

.cancel-btn {
  padding: 8px 30px;
  font-size: 14px;
  font-weight: 600;
  border-color: #acb5bd;
  color: #212529;
}

.cancel-btn:hover {
  background-color: #acb5bd;
  color: #fff;
}

.confirm-btn {
  padding: 8px 50px;
  font-size: 14px;
  font-weight: 600;
}
</style>
